import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=03095bc0&scoped=true&"
var script = {}
import style0 from "./Profile.vue?vue&type=style&index=0&id=03095bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03095bc0",
  null
  
)

export default component.exports